module.exports = __webpack_public_path__ + "static/img/download_apple.7925d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_apple.png
// module id = 93x4
// module chunks = 1